import React, { useEffect, useState } from 'react'
import { sprintActiveStatus } from '../../ProjectManagement/Service/TaskService';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function MyActiveSprints() {
  const [projectDetails, setProjectDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSprintActiveStatus();
  }, []);

  async function getSprintActiveStatus() {
    setLoading(true);
    try {
      let res = await sprintActiveStatus();
      const response = res?.Data || [];
      setLoading(false);
      setProjectDetails(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading ? (
        <div className="og-card-box">
          <div className="ch-box">
            <Skeleton width={70} height={18} />
            <Skeleton width={70} height={18} style={{ marginLeft: 'auto' }} />
          </div>
          <div className="cb-box">
            {[1, 2, 3].map((i) => (
              <div key={i} className="sprint-row">
                <div className="sprint-header">
                  <Skeleton width={120} height={14} />
                  <Skeleton width={70} height={14} />
                </div>
                <Skeleton height={5} style={{ borderRadius: 99, margin: '8px 0' }} />
                <div className="sprint-footer">
                  <Skeleton width={90} height={12} />
                  <Skeleton width={60} height={12} />
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="og-card-box">
          <div className="ch-box">
            <i className="ch-icon fa-solid fa-bolt"></i>
            <h5>My Active Sprints</h5>
            {/* <span className="sprints-badge sprints-success">3 running</span> */}
          </div>
          <div className="cb-box">
            {projectDetails.length > 0 ? (
              projectDetails.slice(0, 3).map((sprint) => {
                const startDate = new Date(sprint.PlannedStartDate);
                const endDate = new Date(sprint.PlannedEndDate);
                const today = new Date();
                const daysLeft = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
                const statusClass = sprint.SprintStatusName?.toLowerCase() === 'paused' ? 'sprints-warning' : 'sprints-success';
                const fillClass = ['fill-green', 'fill-blue', 'fill-amber'][projectDetails.indexOf(sprint) % 3];

                return (
                  <div key={sprint.ID} className="sprint-row">
                    <div className="sprint-header">
                      <div>
                        <span className="sprint-name">Sprint {sprint.SprintNumber}</span>
                        <span className="sprint-project">· {sprint.SprintName}</span>
                      </div>
                      <span className="sprint-tasks">{sprint.ActiveTasksInSprint} / {sprint.TotalTasksInSprint} Tasks</span>
                    </div>
                    <div className="progress-track">
                      <div className={`progress-fill ${fillClass}`}></div>
                    </div>
                    <div className="sprint-footer">
                      {sprint.SprintStatusName?.toLowerCase() === 'paused' ? (
                        <>
                          <span className="sprint-paused"><i className="fa-regular fa-calendar"></i>Ends {endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</span>
                          <span className={`sprints-badge ${statusClass}`}>Paused</span>
                        </>
                      ) : (
                        <>
                          <span className="sprint-date"><i className="fa-regular fa-calendar"></i>Ends {endDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</span>
                          <span className={`sprints-badge ${daysLeft <= 3 ? 'sprints-danger' : 'sprints-info'}`}>{daysLeft} days left</span>
                        </>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>No active sprints</div>
            )}
          </div>
          <div className="card-footer-bx">
            <Link to="/Project/Dashboard" className="link-sm">
              <i className="fa-solid fa-list-check"></i>View all sprints
            </Link>
          </div>
        </div>
      )}
    </>
  )
}

export default MyActiveSprints